<div>Indicate how null records should affect imported values.</div>
<div style="padding-left: 15px; padding-top: 10px;">
    <table>
        @for (option of options; track option) {
            <tr>
                <td style="text-align: left">{{ option.name }}:</td>
                <td style="text-align: left; padding-left: 5px;">{{ option.description }}</td>
            </tr>
        }
    </table>
</div>
